import { Component, Input, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { UserProvajder } from '../../orgjeddefgini/userprovajder/userprovajder';

@Component({
  selector: 'yt-userprovajder-inline-update',
  templateUrl: './userprovajder-inline-update.component.html'
})
export class UserprovajderInlineUpdateComponent extends BaseInlineUpdateComponent<UserProvajder> {

  constructor(protected inlineContainerService: InlineContainerService<UserProvajder>){
    super(inlineContainerService);
  }

}
